import type { ChatCardProps } from "../types/ChatCard";
import type { HelpWidgetMessage } from "../types/help_widget_message";

export const extractButtons = (
  message: HelpWidgetMessage,
  disabled: boolean,
  onActionButtonClick: (message: HelpWidgetMessage, event: string) => void,
) => {
  if (message.buttons) {
    return message.buttons.map(button => ({
      ...button,
      onClick: () => onActionButtonClick(message, button.event),
      disabled,
    }));
  }
  return [];
};

export const extractCards = (message: HelpWidgetMessage) => {
  if (message.cards) {
    return message.cards.map((card: ChatCardProps) => ({
      type: card.type,
      content: card.content,
    }));
  }
  return [];
};
